module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/jb/Code/grupob/~/core-js/modules/_library.js
// module id = 31
// module chunks = 0